module.exports = __webpack_public_path__ + "static/img/4.a4ef6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/4.png
// module id = /sNt
// module chunks = 0